import { render, staticRenderFns } from "./countryFlag.vue?vue&type=template&id=6dbd94e6&scoped=true"
import script from "./countryFlag.vue?vue&type=script&lang=js"
export * from "./countryFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbd94e6",
  null
  
)

export default component.exports